<template>
  <div>

    <table>
      <tbody>
        <tr v-for="i in row" :key="i">
          <td v-for="j in col" :key="j" class="group-table">

            <table class="ma-1">
              <tbody>
                <tr v-for="k in rowInGroup" :key="k">
                  <td v-for="l in colInGroup" :key="l">
                    <img :src="filename(i,j,k,l)" :style="'width:'+ width+'mm'" class="tag-img">
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="showId">
              <span class="caption ma-1" style="line-height:1.0"> {{groupId(i,j)}}</span>
            </div>

          </td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>

export default {
  name: '',
  components: {
  },
  props:{
    row: Number,
    col: Number,
    rowInGroup:Number,
    colInGroup:Number,
    showId:Boolean,
    width:Number
  },
  data() {
    return {
      groupIdList:[]
    }
  },
  watch:{
    rowInGroup(){
      this.makeGroupIdList()
    },
    colInGroup(){
      this.makeGroupIdList()
    },
    row(){
      this.makeGroupIdList()
    },
    col(){
      this.makeGroupIdList()
    }
  },
  methods: {
    groupIdIndex(i,j){
      return (i-1) * this.col + j - 1
    },
    groupId(i,j){
      let groupIdStr ='';
      // groupIdの作成
      this.groupIdList[this.groupIdIndex(i,j)].forEach(id => {
        groupIdStr += ('000' + id ).slice( -3 );
      });
      return groupIdStr
    },
    /**
     * k行l列目のグループ内の、i行j列目のファイル名をグループIDリストから拾って生成する
     */
    filename(i,j,k,l) {

      const groupIndex = this.groupIdIndex(i,j)
      const indexInGroup = (k-1) * this.colInGroup + l - 1
      
      let count = this.groupIdList[groupIndex][indexInGroup]
      // スタートタグじゃないときは1000足す
      if(k!=1||l!=1){
        count += 1000;
      }
      let formatNum = ( '00000' + count ).slice( -5 );
      return require('@/tag/36h10/tag36_10_' + formatNum + '_100x100.png')
    },
    /**
     * グループIDのリストを作る
     * [[22,121,3,710],[9,28,504,33]]
     */
    makeGroupIdList(){
      let max = 999
      this.groupIdList = []
      for(let q=0;q<this.row*this.col;q++){
        let idList = []
        for(let p=0;p<Number(this.rowInGroup)*Number(this.colInGroup);p++){
          idList.push(Math.floor(Math.random()*max))
        }
      this.groupIdList.push(idList)
      }
    }
  },

  created() {
    this.makeGroupIdList()
  },
  mounted(){
    
  }
}
</script>

<style scoped>
td.group-table {
  border: 1px solid #AAA;
}

table {
  border-collapse: collapse;
  border-spacing:0px;
}
td {
  border: none;
  line-height: 0;
}
</style>




// WEBPACK FOOTER //
// src/components/AprilTag/AprilTagExpandHelper.vue